import { CompanyData } from "../types/user";

export enum VatTypes {
  "vat22" = "НДС 22%",
}

export enum UserTypes {
  "legal" = "Юридическое лицо",
  "individual" = "Индивидуальный предприниматель",
  "selfEmployed" = "Самозанятый",
}

export const initialUserData: CompanyData = {
  inn: "",
  phone: "",
  email: "",
  "full-name": "",
  ogrn: "",
  kpp: "",
  "name-organization": "",
  "form-of-organization": VatTypes.vat22,
  "type-of-ownership": UserTypes.individual,
  "general-director": "",
  surname: "",
  "first-name": "",
  patronymic: "",
  okveds: "",
  "passport-series": "",
  "passport-number": "",
  "passport-issue-date": "",
};
